import PropTypes from "prop-types";
import "./AboutSection.css";

function AboutSection({ principles, team }) {
  return (
    <section className="about" id="about" data-reveal>
      <div className="about__inner">
        <div className="about__intro">
          <span className="about__eyebrow">About</span>
          <h2 className="about__title">{team.headline}</h2>
          {team.bio.map((paragraph) => (
            <p key={paragraph} className="about__paragraph">
              {paragraph}
            </p>
          ))}
        </div>
        <div className="about__highlights">
          <h3 className="about__subheading">What sets us apart</h3>
          <ul className="about__list">
            {team.highlights.map((item, index) => (
              <li
                key={item}
                className="about__list-item"
                data-reveal
                data-reveal-delay={index * 80}
              >
                {item}
              </li>
            ))}
          </ul>
          <div className="about__principles">
            {principles.map((principle, index) => (
              <article
                key={principle.title}
                className="principle-card"
                data-reveal
                data-reveal-delay={index * 120}
              >
                <h4 className="principle-card__title">{principle.title}</h4>
                <p className="principle-card__description">{principle.description}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

AboutSection.propTypes = {
  principles: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired
    })
  ).isRequired,
  team: PropTypes.shape({
    headline: PropTypes.string.isRequired,
    bio: PropTypes.arrayOf(PropTypes.string).isRequired,
    highlights: PropTypes.arrayOf(PropTypes.string).isRequired
  }).isRequired
};

export default AboutSection;
